import React from 'react';
import {
  EnvelopeIcon,
  PhoneIcon,
  UserIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

export interface SubTenantItemProps {
  id?: string;
  name: string;
  email?: string;
  phone?: string;
  index?: number;
  onRemove?: (id?: string) => void;
}

const SubTenantItem: React.FC<SubTenantItemProps> = ({
  id,
  name,
  email,
  phone,
  index,
  onRemove
}) => {
  return (
    <div
      key={id ?? `sub-${index ?? 0}`}
      className="group flex items-start p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 hover:shadow-sm transition-all"
    >
      <div className="flex-shrink-0 mr-3">
        <div className="h-8 w-8 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400">
          <UserIcon className="h-4 w-4" />
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 truncate">{name}</p>
        <div className="mt-1 flex items-center gap-3">
          {email ? (
            <a
              href={`mailto:${email}`}
              className="group/item flex items-center text-xs text-gray-500 hover:text-indigo-600 transition-colors"
              title={email}
            >
              <EnvelopeIcon className="h-3.5 w-3.5 mr-1" />
              <span className="hidden group-hover:inline-block truncate max-w-[100px]">
                Email
              </span>
            </a>
          ) : (
            <span className="text-xs text-gray-300 cursor-not-allowed">
              <EnvelopeIcon className="h-3.5 w-3.5" />
            </span>
          )}

          {phone && <div className="w-px h-3 bg-gray-300"></div>}

          {phone && (
            <a
              href={`tel:${phone}`}
              className="group/item flex items-center text-xs text-gray-500 hover:text-indigo-600 transition-colors"
              title={phone}
            >
              <PhoneIcon className="h-3.5 w-3.5 mr-1" />
              <span className="hidden group-hover:inline-block">Call</span>
            </a>
          )}
        </div>
      </div>

      {onRemove && (
        <button
          type="button"
          onClick={() => onRemove(id)}
          className="ml-3 inline-flex items-center rounded-md px-2 py-1 text-xs font-medium text-rose-600 hover:text-rose-700 hover:bg-rose-50 transition"
          aria-label="Remove sub-tenant"
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default SubTenantItem;
